"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _react = _interopRequireDefault(require("react"));
var _ui = require("@unite-us/ui");
function init(Survey, isCreator) {
  var widget = {
    name: 'dropdown-multiselect',
    title: 'Dropdown Multiselect',
    isFit: function isFit(question) {
      return question.getType() === 'dropdown-multiselect';
    },
    isDefaultRender: isCreator,
    iconName: 'icon-dropdown',
    defaultJSON: {
      choices: ["Item 1", "Item 2", "Item 3"]
    },
    widgetIsLoaded: function widgetIsLoaded() {
      return true;
    },
    activatedByChanged: function activatedByChanged() {
      Survey.JsonObject.metaData.addClass('dropdown-multiselect', [], null, 'checkbox');
    },
    render: function render(question) {
      var _context, _question$propertyHas;
      return /*#__PURE__*/_react.default.createElement(_ui.SelectField, {
        id: "select-".concat(question.name),
        label: "",
        options: (0, _map.default)(_context = question.getChoices()).call(_context, function (c) {
          return {
            id: c.value,
            label: c.text
          };
        }),
        valueKey: "id",
        shouldSort: false,
        multiple: true,
        maxSelectedChoices: (_question$propertyHas = question.propertyHash) === null || _question$propertyHas === void 0 ? void 0 : _question$propertyHas.maxSelectedChoices,
        value: question.value ? JSON.parse((0, _stringify.default)(question.value)) : question.value,
        searchThreshold: 0.4,
        onChange: function onChange(selectedOption) {
          question.setValueCore((0, _map.default)(selectedOption).call(selectedOption, function (e) {
            return e.id;
          }));
        }
      });
    }
  };
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
}
//# sourceMappingURL=DropdownMultiselectWidget.js.map